// export const parentUid = 14;
export const parentUid = 77;
// export const Url = `http://localhost:3010`;
export const security_key = `dfrhiuf78UY7CTYC76rft78387tVnjkGUVIG-HSVCXDXZRKPVUY.7695fgyuvu8`;
export const Url = 'https://jfapi.jasonsfurnitureoutlet.com';




export const DYRUrl = '';
export const baseURL = "https://jasonsfurnitureoutlet.com/";

export function formatTimestamp(timestamp) {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const formatPrice = (price) => {
  return new Intl.NumberFormat('en-us', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: price % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(price);
};

export function getUSGreeting() {
  const now = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
  const currentHour = new Date(now).getHours();
  if (currentHour < 12) {
    return "Good Morning";
  } else if (currentHour < 17) {
    return "Good Afternoon";
  } else {
    return "Good Evening";
  }
}

export const site_url = '';



export function createSlug(productName) {
  return productName
    .toLowerCase() // convert to lowercase
    .trim() // remove leading/trailing spaces
    .replace(/&/g, 'and') // replace & with 'and'
    .replace(/[\/\\]+/g, '-') // replace slashes with hyphen
    .replace(/[^a-z0-9\s-]/g, '') // remove special characters except space and hyphen
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // collapse multiple hyphens
}



export function formatCurrencyValue(value) {
  if (value === null || value === undefined || value === '') return '0';

  const number = Number(value);
  if (isNaN(number)) return '0';

  const hasDecimal = number % 1 !== 0;

  return number.toLocaleString('en-US', {
    minimumFractionDigits: hasDecimal ? 2 : 0,
    maximumFractionDigits: hasDecimal ? 2 : 0,
  });
}


export function getAdjustedPrice(value) {
  // Convert value to number first
  const numericValue = Number(value);

  if (isNaN(numericValue)) {
    return 0; // Fallback for invalid input
  }

  if (numericValue < 1000) {
    return Math.round(numericValue / 25);
  } else {
    return Math.round(numericValue / 26);
  }
}



export const cart_protected_value = 199;
export const product_protected_value = 149;
export const product_protected_value_dual = 199;
export const professional_assembly_value = 199;


export function calculateCartTotal(cart) {
  if (!cart || !cart.products) return 0;

  let total = 0;

  // Step 1: Add product totals (sale_price * quantity)
  cart.products.forEach((product) => {
    const price = parseFloat(product.sale_price);
    const quantity = product.quantity || 1;
    total += price * quantity;

    // Step 2: Add $149 per product if not all protected and product is protected
    if (cart.is_all_protected === 0 && product.is_protected === 1) {
      total += product_protected_value;
    }
  });

  // Step 3: Add $149 if cart is fully protected
  if (cart.is_all_protected === 1) {
    total += cart_protected_value;
  }

  // Step 4: Add $199 if professional assembly is selected
  if (cart.is_professional_assembly === 1) {
    total += professional_assembly_value;
  }

  return total;
}


export function calculateCartSubtotal(cart) {
  if (!cart || !cart.products) return 0;

  let subtotal = 0;

  // Step 1: Product prices × quantities
  cart.products.forEach((product) => {
    const price = parseFloat(product.sale_price) || 0;
    const quantity = product.quantity || 1;
    subtotal += price * quantity;

    // Step 2: Add $149 per product if not all protected and this product is protected
    if (cart.is_all_protected === 0 && product.is_protected === 1) {
      subtotal += product_protected_value;
    }
  });

  // Step 3: Add $199 if cart is fully protected
  // if (cart.is_all_protected === 1) {
  //   subtotal += cart_protected_value;
  // }

  // Step 4: Do NOT add professional assembly here

  return subtotal;
}




export const configEditor_upd = {
  buttons: [
    "bold",
    "italic",
    "underline",
    "strikethrough",
    "|",
    "paragraph",
    "fontsize",
    "lineHeight",
    "|",
    "ul",
    "ol",
    "|",
    "align",
    "undo",
    "redo",
  ],
  style: {
    fontFamily: "var(--font-family)",
    fontSize: "var(--font-size-small)",
    lineHeight: "1.6",
    color: "var(--text-color-1)",
    height: "400px",
  },
  toolbarAdaptive: false,
  toolbarSticky: false,

  // 👇 Force plain text only
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
  pastePlain: true, // ✅ this is the key
  cleanHTML: {
    cleanOnPaste: true,   // clean pasted HTML
    removeStyles: true,   // ✅ remove all inline styles
    removeClasses: true,  // ✅ remove class names
  },
};



export const imageConfigEditor = {
  buttons: [
    "bold",
    "italic",
    "underline",
    "strikethrough",
    "|",
    "paragraph",
    "fontsize",
    "lineHeight",
    "|",
    "ul",
    "ol",
    "|",
    "align",
    "image", // only in this config
    "undo",
    "redo",
  ],
  style: {
    fontFamily: "var(--font-family)",
    fontSize: "var(--font-size-small)",
    lineHeight: "1.6",
    color: "var(--text-color-1)",
    height: "400px",
  },
  toolbarAdaptive: false,
  toolbarSticky: false,

  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
  pastePlain: true,
  cleanHTML: {
    cleanOnPaste: true,
    removeStyles: true,
    removeClasses: true,
  },

  // uploader: {
  //   url: Url + "/api/v1/media/blogs/add",
  //   method: "POST",
  //   filesVariableName: () => "image", // matches API field
  //   insertImageAsBase64URI: false,
  //   process: function (resp) {
  //     try {
  //       if (!resp || !resp.media || !resp.media.image_url) {
  //         console.error("Invalid upload response:", resp);
  //         return { files: [] };
  //       }

  //       console.log(resp,"here");

  //       let imageUrl = resp.media.image_url;

  //       if (!/^https?:\/\//i.test(imageUrl)) {
  //         imageUrl = `${Url}${imageUrl}`;
  //       }

  //       return { files: [imageUrl] }; // ✅ This is what Jodit needs
  //     } catch (err) {
  //       console.error("Process error:", err);
  //       return { files: [] };
  //     }
  //   },
  //   error: function (e) {
  //     console.error("Image upload failed:", e);
  //     return { files: [] };
  //   }
  // }
  uploader: {
    url: Url + "/api/v1/media/blogs/add",
    method: "POST",
    filesVariableName: () => "image",
    insertImageAsBase64URI: false,
    prepareData: function (formData) {
      return formData; // don’t alter
    },
    isSuccess: (resp) => !!(resp && resp.media && resp.media.image_url), // ✅ skip default success check
    process: function (resp) {
      try {
        if (!resp || !resp.media || !resp.media.image_url) {
          console.error("Invalid upload response:", resp);
          return { files: [] };
        }

        let imageUrl = resp.media.image_url;

        // ✅ Only prepend if it's a relative path
        if (!/^https?:\/\//i.test(imageUrl)) {
          imageUrl = `${imageUrl}`;
        }

        return {
          files: [imageUrl],
          path: imageUrl,
          baseurl: Url,
          isImages: [true]
        };
      } catch (err) {
        console.error("Process error:", err);
        return { files: [] };
      }
    },

    error: function (e) {
      console.error("Upload failed:", e);
      return { files: [] };
    }
  }

};
